import { render, staticRenderFns } from "./formForgottenPassword.vue?vue&type=template&id=6d98c934"
import script from "./formForgottenPassword.vue?vue&type=script&lang=js"
export * from "./formForgottenPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports